import React, { useRef, useEffect } from "react";
export default function LoginAluno(props) {
  const containerRef = useRef(null);
  useEffect(() => window.DMAccess.mountLogin(containerRef.current), []);
  return <div ref={containerRef} />;
}
export { LoginAluno };
